module.exports = __webpack_public_path__ + "static/media/LIO-Logos-SE.c39fe2fc.png";